import { toLegacyDetail, toLegacyPaginated, v1Delete, v1Get, v1Post, v1Put } from '@/services/v1Api';

/**
 * Get all payment terms
 * @param {Object} params - Query parameters (search, active, sort_by, sort_order, per_page, page)
 * @returns {Promise} API response
 */
export const getPaymentTerms = async (params = {}) => {
    try {
        const query = {};
        if (params.search) query.search = params.search;
        if (params.active !== undefined) query.active = params.active;
        if (params.sort_by) query.sort_by = params.sort_by;
        if (params.sort_order) query.sort_order = params.sort_order;
        if (params.per_page) query.per_page = params.per_page;
        if (params.page) query.page = params.page;

        const { data, meta } = await v1Get('/api/v1/payment-terms', query);
        return toLegacyPaginated(data, meta);
    } catch (error) {
        console.error('Error fetching payment terms:', error);
        throw error;
    }
};

/**
 * Get a single payment term by ID
 * @param {number|string} id - Payment term ID
 * @returns {Promise} API response
 */
export const getPaymentTermById = async (id) => {
    try {
        const { data } = await v1Get(`/api/v1/payment-terms/${id}`);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error fetching payment term by ID:', error);
        throw error;
    }
};

/**
 * Create a new payment term
 * @param {Object} paymentTermData - Payment term data (name, description, days, is_active, sort_order)
 * @returns {Promise} API response
 */
export const createPaymentTerm = async (paymentTermData) => {
    try {
        const { data } = await v1Post('/api/v1/payment-terms', paymentTermData);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error creating payment term:', error);
        throw error;
    }
};

/**
 * Update a payment term
 * @param {number|string} id - Payment term ID
 * @param {Object} paymentTermData - Payment term data (all fields optional)
 * @returns {Promise} API response
 */
export const updatePaymentTerm = async (id, paymentTermData) => {
    try {
        const { data } = await v1Put(`/api/v1/payment-terms/${id}`, paymentTermData);
        return toLegacyDetail(data);
    } catch (error) {
        console.error('Error updating payment term:', error);
        throw error;
    }
};

/**
 * Delete a payment term
 * @param {number|string} id - Payment term ID
 * @returns {Promise} API response
 */
export const deletePaymentTerm = async (id) => {
    try {
        await v1Delete(`/api/v1/payment-terms/${id}`);
        return { success: true };
    } catch (error) {
        console.error('Error deleting payment term:', error);
        throw error;
    }
};
